import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';

import App from './App';

const posthogKey = import.meta.env.VITE_POSTHOG_API_KEY;
const posthogHost = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com';

if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    autocapture: {
      dom_event_allowlist: ['click', 'submit'],
      element_allowlist: ['button', 'a', 'form', 'input'],
    },
    capture_pageview: true,
    capture_pageleave: true,
    capture_exceptions: true,
  });
}

const content: React.ReactNode = posthogKey ? (
  <PostHogProvider client={posthog}>
    <App />
  </PostHogProvider>
) : (
  <App />
);

// Type assertion: conflicting @types/react between project and @types/react-dom's nested dependency
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>{content}</React.StrictMode> as never,
);
